import React, { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';

import { getComma } from '@/util/format';
import { getRefundAmount } from '@/util/getRefundAmount';
import Typography from '../common/Typography';
import FlexWrap from '../common/FlexWrap';
import LoadingView from '../common/LoadingView';
import PortePaymentList from './porte/PortePaymentList';
import { isCustom } from '@/constants/common';

type Props = {
  isPayment: boolean;
  setLeafletModalInfo: Dispatch<
    SetStateAction<{
      active: boolean;
      isOver600: boolean;
      isKioskError: boolean;
    }>
  >;
  errorMessage: {
    isSubmit: boolean;
    message: string;
  };
  onClickSaveBtn: () => void;
  onClickRefundBtn: any;
  isLoading: boolean;
  isPassportCheck: boolean;
  isFetchedStorageData: boolean;
  supplyList: {
    productType: string;
    price: string;
    supplyPrice: string;
    vatPrice: string;
    isCheck: boolean;
  }[];
  isCustomKor: boolean;
  setIsDuplicateRefund: (value: boolean) => void;
};
function AmountDetailDummy({
  isCustomKor,
  setLeafletModalInfo,
  errorMessage,
  onClickSaveBtn,
  onClickRefundBtn,
  isLoading,
  isPassportCheck,
  isFetchedStorageData,
  supplyList,
  setIsDuplicateRefund,
}: Props) {
  // 더미 상태 관리
  const [totalPayPrice] = useState(0);
  const [paymentCard] = useState('0');
  const [paymentCash] = useState('0');

  // 더미 데이터
  const hospitalId = 0;
  const isAutoPayment = false;
  const isDirectPayment = false;
  const isDirectPassport = false;
  const isDisabledRefundButton = true;

  // 더미 함수들
  const register = (..._args: any[]) => ({});
  const onChangePrice = () => {};

  const handleClickRefund = async () => {};

  return (
    <>
      {/* 커스텀 의원이고 600 만원을 초과하는 경우 */}
      {isCustom(hospitalId) && totalPayPrice > 6000000 && !isCustomKor ? (
        <PortePaymentList
          supplyList={supplyList}
          totalPayment={totalPayPrice}
        />
      ) : (
        <PaymentContainer isFullPayment={!isAutoPayment}>
          <Payment isFullPayment>
            <PaymentMethod>총 시술 금액</PaymentMethod>
            <PaymentPrice
              readOnly
              type='text'
              value={getComma(totalPayPrice)}
            />
            <UnitText>원</UnitText>
          </Payment>
          <Payment isFullPayment>
            <PaymentMethod>환급액</PaymentMethod>
            <PaymentPrice
              readOnly
              type='text'
              value={getComma(getRefundAmount(totalPayPrice))}
            />
            <UnitText>원</UnitText>
          </Payment>
          <Payment isFullPayment>
            <PaymentMethod>카드 결제</PaymentMethod>
            <PaymentPrice
              readOnly
              {...register('paymentCard')}
              type='text'
              value={paymentCard}
            />
            <UnitText>원</UnitText>
          </Payment>
          <Payment>
            <PaymentMethod>현금 결제</PaymentMethod>
            {/* 
            TODO - 임시저장 환급 에러 참고
            console.log(paymentCash)
            onChangePrice 함수 동작 참고
            */}
            <PaymentPrice
              {...register('paymentCash')}
              type='text'
              onChange={onChangePrice}
              value={paymentCash}
              placeholder='현금 결제금액 입력'
              disabled={Boolean(!totalPayPrice)}
            />
            <UnitText>원</UnitText>
          </Payment>
        </PaymentContainer>
      )}
      {/* 커스텀 의원 */}
      <FinalAmountSection dir='column' gap='16px'>
        <FinalAmountWrapper justifyContent='space-between'>
          <FlexWrap>
            <Label>최종 결제 금액</Label>

            {/* 커스텀 의원 + 한국인 예외처리 */}
            {isCustom(hospitalId) && !isCustomKor ? (
              <FinalPaymentPrice>
                <FinalPriceValue
                  isColorRed={isDirectPayment && Boolean(isAutoPayment)}
                >
                  {getComma(totalPayPrice - getRefundAmount(totalPayPrice))}
                </FinalPriceValue>
                <FinalPriceUnit>원</FinalPriceUnit>
              </FinalPaymentPrice>
            ) : (
              <FinalPaymentPrice>
                <FinalPriceValue
                  isColorRed={isDirectPayment && Boolean(isAutoPayment)}
                >
                  {isAutoPayment && !isDirectPayment && !isDirectPassport
                    ? getComma(totalPayPrice - getRefundAmount(totalPayPrice))
                    : getComma(totalPayPrice)}
                </FinalPriceValue>
                <FinalPriceUnit>원</FinalPriceUnit>
              </FinalPaymentPrice>
            )}
            {/* 커스텀 의원 */}
          </FlexWrap>

          <FlexWrap alignItems='center' gap='15px'>
            {Boolean(errorMessage.message) && (
              <ErrorMessage>{errorMessage.message}</ErrorMessage>
            )}
            <Button temporaryStorage onClick={onClickSaveBtn}>
              임시저장
            </Button>
            {/* {isOriginalTabletUser ? (
              <RefundCheckButton
                totalPayPrice={totalPayPrice}
                isCustomKor={isCustomKor}
                isDisabledRefundButton={isDisabledRefundButton}
                onClickRefundBtn={handleClickRefund}
              />
            ) : ( */}
            <Button
              isValidate={!isDisabledRefundButton}
              disabled={isDisabledRefundButton}
              onClick={handleClickRefund}
            >
              {isLoading ? <LoadingView /> : '확인'}
            </Button>
            {/* )} */}
          </FlexWrap>
        </FinalAmountWrapper>

        {isFetchedStorageData && !isPassportCheck && (
          <AlertText>
            <Red>[여권 확인] 버튼을 먼저 눌러주세요</Red>
          </AlertText>
        )}
        {/* 커스텀 의원이 아닌 경우 */}
        {!isCustom(hospitalId) && isAutoPayment && isDirectPayment && (
          <AlertText>
            시술 <Red>금액 전체를 결제</Red>해주세요. 결제가 끝나면
            <Red> 환급 안내서를 환자에게 전달</Red>해주세요.
          </AlertText>
        )}
        {/* {hospitalId === 70 && (
					<AlertText>
						금액 수정 시 <Red>정보 수정</Red> - <Red> 여권 확인</Red>을 통해
						금액을 재입력 해주세요.
					</AlertText>
				)} */}
      </FinalAmountSection>
    </>
  );
}

const PaymentContainer = styled.div<{ isFullPayment?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ececec;
  padding: 16px;
  border-radius: 16px;
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;

  * {
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none !important;
  }
  @media ${(props) => props.theme.largeView} {
    padding: 24px 32px;
  }
`;

export const Payment = styled.div<{ isFullPayment?: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const PaymentMethod = styled.p`
  padding: 12px 16px;
  font-size: ${(props) => props.theme.fontSize.xSmall};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  line-height: ${(props) => props.theme.lineHeight.xSmall};
  color: ${(props) => props.theme.mono[80]};
`;

export const PaymentPrice = styled.input<{ readOnly?: boolean }>`
  border: ${(props) =>
    props.readOnly ? 'none' : `1px solid ${props.theme.mono[20]}`};
  background-color: ${(props) =>
    props.readOnly ? props.theme.mono[5] : '#ffffff'};
  flex: 0.8;
  border-radius: 4px;
  padding: 16px 32px 16px 16px;
  text-align: right;
  ::placeholder {
    color: ${(props) => props.theme.mono[50]};
  }
  font-size: ${(props) => props.theme.fontSize.xSmall};
  min-width: 120px;
  max-width: 212px;
  @media ${(props) => props.theme.mediumView} {
    flex: 1;
  }
`;

export const UnitText = styled.span`
  transform: translateX(-24px);
  font-size: 12px;
  color: ${(props) => props.theme.mono[35]};
`;
const RefundMethodContainer = styled(FlexWrap)`
  align-items: center;
  border: 1px solid #cbccce;
  background-color: #ececec;
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;

  * {
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none !important;
  }
`;
const RefundMethod = styled(FlexWrap)`
  cursor: pointer;
  gap: 8px;
`;
const RefundMethodTitle = styled(FlexWrap)`
  height: 100%;
  align-items: center;
  padding: 12px 100px;
  background-color: #d7dfe4;
`;
const StyledRadio = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 4px solid #cbccce;
  cursor: pointer;
  &::disabled {
    cursor: default;
  }
  &:checked {
    border: 4px solid #354eff;
    background-color: #ffffff;
  }
`;

const FinalAmountSection = styled(FlexWrap)`
  background-color: #ececec;
  padding: 16px;
  border-radius: 16px;
  justify-content: space-between;
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;

  * {
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none !important;
  }
  @media ${(props) => props.theme.largeView} {
    padding: 24px 32px;
  }
`;
const Label = styled.label`
  font-size: ${(props) => props.theme.fontSize.small};
  line-height: 50px;
  font-weight: 600;
  color: ${(props) => props.theme.mono[80]};
`;
const FinalPaymentPrice = styled(FlexWrap)`
  align-items: center;
  border: 1.5px solid ${(props) => props.theme.mono[20]};
  border-radius: 4px;
  gap: 4px;
  padding: 8px 16px;
  margin-left: 30px;
  width: 324px;
  justify-content: end;
  @media ${(props) => props.theme.largeView} {
    width: 548px;
  }
`;
const FinalAmountWrapper = styled(FlexWrap)`
  width: 100%;
`;
const FinalPriceValue = styled.p<{ isColorRed: boolean }>`
  font-size: ${(props) => props.theme.fontSize.medium};
  line-height: 150%;
  font-weight: bold;
  color: ${(props) => (props.isColorRed ? '#FF2D55' : props.theme.mono[80])};
`;
const FinalPriceUnit = styled.span`
  font-size: ${(props) => props.theme.fontSize.xSmall};
  line-height: 150%;
  color: ${(props) => props.theme.mono[50]};
`;
const Red = styled.span`
  color: red;
`;

const AlertText = styled.p`
  color: ${(props) => props.theme.mono[80]};
  font-size: ${(props) => props.theme.fontSize.regular};
  margin-left: auto;
  font-weight: 500;
`;

const Button = styled.button<{
  isValidate?: boolean;
  temporaryStorage?: boolean;
}>`
  width: ${(props) => (props.temporaryStorage ? '200px' : '240px')};
  height: 52px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.medium};
  color: ${(props) =>
    props.temporaryStorage ? props.theme.mono[80] : '#ffffff'};
  background-color: ${(props) =>
    props.temporaryStorage
      ? props.theme.mono[10]
      : props.isValidate
      ? '#CCCCCC'
      : '#CCCCCC'};
  :hover {
    opacity: 0.7;
  }
`;

const ErrorMessage = styled.p`
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.theme.priamryColors.error};
`;

export default AmountDetailDummy;
